import { Edit, Plus } from 'lucide-react';
import BankLogo from '@/domains/mobile-web/components/BankLogo/BankLogo';
import InfoNote from '@/domains/mobile-web/components/InfoNote/InfoNote';
import Button from '@/shared/components/ui/Button';

interface CardAccountBankProps {
  /** DOKU bank code */
  bankCode?: string;
  bankName?: string;
  accountNumber?: string;
  name?: string;
  onEdit?: () => void;
  onAddAccount?: () => void;
  showBankAccount?: boolean;
}

const CardAccountBank = ({
  bankCode,
  name,
  bankName,
  accountNumber,
  onEdit,
  onAddAccount,
  showBankAccount,
}: CardAccountBankProps) => {
  return (
    <div className="shadowCard p-3 gap-3 flex flex-col w-full">
      <p className="title2medium">Rekening Tujuan</p>
      {showBankAccount && bankCode && (
        <div className="w-full flex items-center gap-3 justify-between rounded-[12px] border border-blue-cs-200 px-4 py-2">
          <div className="w-fit inline-flex gap-3 items-center">
            <BankLogo code={bankCode} name={bankName} />
            <div className="text-black">
              <div className="body1bold inline-flex gap-1 items-center">
                <span className="">{bankName}</span>
                <span className="">{accountNumber}</span>
              </div>
              {name && <p className="body1">a/n {name}</p>}
            </div>
          </div>
          <button
            type="button"
            className="text-text-blue-100 cursor-pointer"
            onClick={onEdit}
            aria-label="Ubah rekening"
          >
            <Edit size={20} />
          </button>
        </div>
      )}

      {!showBankAccount && (
        <Button className="btn-fill-blue" onClick={onAddAccount}>
          <Plus />
          <span>Tambah Rekening</span>
        </Button>
      )}

      <InfoNote>
        Komisi penjualan akan dikreditkan ke akun anda dalam waktu <strong>5 hari kerja</strong>{' '}
        setelah pelanggan menerima produk
      </InfoNote>
    </div>
  );
};

export default CardAccountBank;
